// extracted by mini-css-extract-plugin
module.exports = {"tenderDetails":"TenderPortDetails_tenderDetails__gFy32","tenderMessage":"TenderPortDetails_tenderMessage__LbOqH","tenderLearnMore":"TenderPortDetails_tenderLearnMore__HLtAF"};